import { useParams } from 'react-router';

export const usePeoPayrollProviderParamId = () => {
  const { peoPayrollProviderId } = useParams<{ peoPayrollProviderId: string }>();
  return peoPayrollProviderId;
};
